module.exports = __webpack_public_path__ + "assets/img/81f45996f0fcacf18afb7948c6b558b2.svg";